module.exports = __webpack_public_path__ + "static/media/instagram.7d96cde6.png";